import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export interface BookletStatusInfo {
  status: string;
  label: string;
  description: string;
  className: string;
  icon: string;
}

@Component({
  selector: 'casa-doc-booklet-status-legend',
  templateUrl: './booklet-status-legend.component.html',
  styleUrls: ['./booklet-status-legend.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookletStatusLegendComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly statuses: BookletStatusInfo[] = [
    {
      status: 'NEW',
      label: 'Nuovo',
      description: 'Libretto appena creato. Non ha ancora raggiunto lo stato di istruttoria.',
      className: 'new',
      icon: 'fiber_new',
    },
    {
      status: 'DUE_DILIGENCE',
      label: 'In Istruttoria',
      description:
        'È stata inserita la data di accesso agli atti. ' + 'Il libretto è in fase di raccolta documenti.',
      className: 'in-progress',
      icon: 'pending_actions',
    },
    {
      status: 'DOC_READY',
      label: 'Doc Pronti',
      description: `
      <strong>Documenti libretto:</strong> Catasto ed urbanistica devono essere entrambi caricati e conformi <br/>
      <strong>Relazione tecnica:</strong>  Deve essere sempre caricata. Non si verifica che sia conforme. <br/>
      <strong>Atto di provenienza:</strong> Deve essere sempre caricato e deve essere popolato il campo  "proprietari". Non si verifica che sia conforme. <br/>
      <strong>Ape:</strong> Se richiesta deve essere caricata. Non si verifica che sia conforme. <br/>
      <strong>Extra:</strong> Se riechiesto deve essere caricato. Non si verifica che sia conforme.
`,
      className: 'doc-ready',
      icon: 'check_circle',
    },
    {
      status: 'ARCHIVED',
      label: 'Archiviato',
      description:
        'Libretto chiuso e archiviato. Sono stati pagati tutti i collaboratori ' +
        'e tecnici. La fattura Casa Doc è stata inviata e caricata.',
      className: 'archived',
      icon: 'inventory_2',
    },
    {
      status: 'INACTIVE',
      label: 'Inattivo',
      description:
        'Libretto annullato o non più valido. Non è più necessario portarlo a ' +
        'termine. Non viene considerato nella dashboard e nella vista contabile.',
      className: 'inactive',
      icon: 'cancel',
    },
    {
      status: 'AUTO',
      label: 'Automatico',
      description: 'Pratica in modalità automatica.',
      className: 'auto',
      icon: 'smart_toy',
    },
  ];

  trackByStatus(_index: number, status: BookletStatusInfo): string {
    return status.status;
  }

  sanitizeHtml(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
